import { t } from '@lingui/macro';
import React from 'react';

import Alert from './Alert';
import { ExpiredPasskeyAlertProps } from './types';

/**
 * ExpiredPasskeyAlert Component
 * Shows alert for expired passkeys
 * Displayed when existing passkey has passed its expiration date
 */
const ExpiredPasskeyAlert: React.FunctionComponent<ExpiredPasskeyAlertProps> = ({
  libraryName,
  displayExpirationDate,
  showNewPasskeyField,
  onUpdateClick
}) => {
  const headerText = t`The previous passkey on this ${libraryName} expired on ${displayExpirationDate}`;

  const messageLines = [
    t`Non-registered users can no longer access this ${libraryName} using the previous passkey.`,
    showNewPasskeyField ? '' : t`UPDATE_BUTTON and share it with these users to restore their access.`
  ].filter((line) => line !== ''); // Remove empty lines when input is shown

  return (
    <Alert
      headerText={headerText}
      messageLines={messageLines}
      onUpdateClick={onUpdateClick}
      showUpdateButton={!showNewPasskeyField}
    />
  );
};

export default ExpiredPasskeyAlert;
